import { render, staticRenderFns } from "./LandingMerchantFaq.vue?vue&type=template&id=109b00fc"
import script from "./LandingMerchantFaq.vue?vue&type=script&lang=js"
export * from "./LandingMerchantFaq.vue?vue&type=script&lang=js"
import style0 from "./LandingMerchantFaq.vue?vue&type=style&index=0&id=109b00fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports